{
    "m3WorkflowBuilder": {
        "title": "M3 Workflow Builder",
        "subtitle": "Sélectionnez un programme et une transaction pour afficher les métadonnées",
        "connection": "Connexion",
        "connectionPlaceholder": "Sélectionnez une connexion...",
        "program": "Programme",
        "programPlaceholder": "Rechercher et sélectionner un programme...",
        "programCount": "{count} programmes",
        "transaction": "Transaction",
        "transactionPlaceholder": "Rechercher et sélectionner une transaction...",
        "inputFields": "Champs d'entrée",
        "outputFields": "Champs de sortie",
        "fieldCount": "{count} champs",
        "fieldName": "Nom",
        "fieldDescription": "Description",
        "fieldType": "Type",
        "fieldLength": "Longueur",
        "fieldMandatory": "Obligatoire",
        "required": "Requis",
        "noInputFields": "Aucun champ d'entrée",
        "noOutputFields": "Aucun champ de sortie",
        "createWorkflow": "Créer un workflow",
        "workflowName": "Nom du workflow",
        "workflowNamePlaceholder": "Entrez le nom du workflow",
        "create": "Créer",
        "creating": "Création...",
        "workflowCreated": "Créé",
        "workflowCreatedSuccess": "Workflow créé avec succès !",
        "workflowId": "ID du workflow",
        "workflowCreateFailed": "Échec de la création du workflow",
        "runWorkflow": "Exécuter le workflow",
        "runInfo": "Pour qu'un workflow puisse être utilisé dans l'App Builder, il doit avoir été déclenché au moins une fois. Veuillez le faire ci-dessous.",
        "run": "Exécuter le workflow",
        "running": "Exécution...",
        "workflowResult": "Résultat du workflow",
        "recordCount": "{count} enregistrement(s)",
        "noRecords": "Aucun enregistrement retourné",
        "error": "Erreur",
        "field": "Champ",
        "loadConnectionsError": "Échec du chargement des connexions",
        "loadProgramsError": "Échec du chargement des programmes",
        "loadTransactionsError": "Échec du chargement des transactions",
        "loadFieldsError": "Échec du chargement des champs de transaction",
        "createWorkflowError": "Échec de la création du workflow",
        "runWorkflowError": "Échec de l'exécution du workflow",
        "menuLabel": "M3 Workflow Builder"
    }
}
